import { render } from "./FacebookAutomationWorkbench.vue?vue&type=template&id=11aa73f3&scoped=true"
import script from "./FacebookAutomationWorkbench.vue?vue&type=script&lang=js"
export * from "./FacebookAutomationWorkbench.vue?vue&type=script&lang=js"

import "./FacebookAutomationWorkbench.vue?vue&type=style&index=0&id=11aa73f3&scoped=true&lang=css"
import "./FacebookAutomationWorkbench.vue?vue&type=style&index=1&id=11aa73f3&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11aa73f3"]])

export default __exports__